import React from 'react';
import {Button, Modal, Panel} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import FaPencil from 'react-icons/lib/fa/pencil';
import TeamsPanel from '../teams/TeamsPanel';
import './ProgramPage.css';
import NotFoundPage from '../NotFoundPage';
import {clearErrors, deleteTeam, getContacts, getPrograms, getTeams,} from '../utils/actions';
import connect from 'react-redux/es/connect/connect';
import ErrorComponent from '../ErrorComponent';

class ProgramPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      rte: {},
      showRte: false,
      notFound: false
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    this.props.clearError();
    this.props.fetchPrograms({programId: this.props.match.params.programId});
    this.props.fetchTeams({programId: this.props.match.params.programId});
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.programs.isLoading && !this.props.programs.isLoading) {
      let program = this.props.programs.data[this.props.match.params.programId];
      if (program.rte_id) {
        this.props.fetchContacts({ contactId: program.rte_id });
      }
    }
    if (prevProps.contacts.isLoading && !this.props.contacts.isLoading) {
      this.setState({ rte: this.props.contacts.data[this.getProgram().rte_id] || {} });
    }
  }
  
  getProgram = () => {
    return this.props.programs.data[this.props.match.params.programId];
  };

  isLoading = () => {
    return !this.getProgram();
  };

  handleClose() {
    this.setState({ showRte: false });
  }

  handleShow() {
    this.setState({ showRte: true });
  }

  getRteName() {
    return this.state.rte && this.state.rte.first_name ?
      this.state.rte.first_name + ' ' + this.state.rte.last_name : '';
  }

  render() {
    if(this.state.notFound) {
      return <NotFoundPage/>;
    }
    if (this.isLoading()) return <p>Loading...</p>;

    return (
      <div>
        { this.props.errors.length > 0 &&
          <ErrorComponent error={this.props.errors}/>
        }
        <div className='flex-row-spaced'>
          <h2 data-cy="program-header" className='m0'>
            Program: &nbsp; {this.getProgram().name}
          </h2>
          <div>
            <Link to={`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/edit`}>
              <Button data-cy="edit-program-button" className="primary"><FaPencil /></Button>
            </Link>
          </div>
        </div>

        <TeamsPanel
          company_id={this.props.match.params.companyId}
          program_id={this.props.match.params.programId}
          teams={Object.values(this.props.teams.data)}
          showButtons={true}
          deleteTeam={this.props.deleteTeam}
        />

        <Panel>
          <Panel.Heading>
            <Panel.Title className="h3">Details</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <h4>
              {'Release Train Engineer: '}
              <a  data-cy="rte" onClick={this.handleShow}>{this.getRteName()}</a>
            </h4>
          </Panel.Body>
        </Panel>

        <Modal show={this.state.showRte} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.getRteName()}
              <Link
                className='pull-right pr1'
                to={`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/edit#rte`}>
                <Button data-cy="change-rte" className='primary'>Change R.T.E.</Button>
              </Link>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p data-cy="rte-email">Email: {this.state.rte.email}</p>
            {this.state.rte.phone && <p data-cy="rte-phone">Phone: {this.state.rte.phone}</p>}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({ programs: state.programs, teams: state.teams, errors: state.errors, contacts: state.contacts });

const mapDispatchToProps = dispatch => ({
  fetchPrograms: (query) => dispatch(getPrograms(query)),
  fetchTeams: (query) => dispatch(getTeams(query)),
  fetchContacts: (query) => dispatch(getContacts(query)),
  deleteTeam: (id) => dispatch(deleteTeam(id)),
  clearError: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgramPage);


// WEBPACK FOOTER //
// ./src/components/program/ProgramPage.js